import React from 'react';
import { useLocation } from 'react-router-dom';
import RelatedServices from './RelatedServices';
import ContentRecommendations from './ContentRecommendations';

interface ServicePageLayoutProps {
  children: React.ReactNode;
  showRelatedServices?: boolean;
  relatedServicesCount?: number;
  relatedServicesTitle?: string;
  showContentRecommendations?: boolean;
  contentRecommendationsCount?: number;
  contentRecommendationsTitle?: string;
  contentRecommendationsSubtitle?: string;
  preferredContentTypes?: string[];
}

/**
 * A layout component for service pages that automatically adds:
 * 1. RelatedServices - to resolve orphan page issues by creating incoming links
 * 2. ContentRecommendations - to resolve pages with no outgoing links
 */
const ServicePageLayout: React.FC<ServicePageLayoutProps> = ({
  children,
  showRelatedServices = true,
  relatedServicesCount = 3,
  relatedServicesTitle = "Related Services You May Need",
  showContentRecommendations = true,
  contentRecommendationsCount = 2,
  contentRecommendationsTitle = "Recommended Resources",
  contentRecommendationsSubtitle = "Explore more helpful content from our academic experts",
  preferredContentTypes = ['blog', 'informational']
}) => {
  const location = useLocation();

  return (
    <div className="service-page-layout">
      {children}
      
      {showRelatedServices && (
        <div className="related-services-container">
          <RelatedServices 
            currentPath={location.pathname} 
            count={relatedServicesCount}
            title={relatedServicesTitle}
          />
        </div>
      )}

      {showContentRecommendations && (
        <div className="content-recommendations-container">
          <ContentRecommendations 
            currentPath={location.pathname}
            count={contentRecommendationsCount}
            title={contentRecommendationsTitle}
            subtitle={contentRecommendationsSubtitle}
            preferredTypes={preferredContentTypes}
          />
        </div>
      )}
    </div>
  );
};

export default ServicePageLayout; 